module.exports = {"430302001":"雨湖路街道","430302002":"城正街街道","430302003":"平政路街道","430302004":"云塘街道","430302005":"广场街道","430302006":"中山路街道","430302007":"窑湾街道","430302008":"羊牯塘街道","430302010":"昭潭街道","430302011":"万楼街道","430302012":"先锋街道","430302100":"鹤岭镇","430302101":"楠竹山镇","430302102":"姜畲镇","430302202":"长城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430302.json
// module id = 1670
// module chunks = 0